import React from 'react'
import KeyboardBackspace from '@material-ui/icons/KeyboardBackspace'
import { Tooltip } from '@material-ui/core'

export function Arrow(props: { display?: boolean; tip?: string }) {
  const display = props.display ? props.display : true
  const tip = props.tip ? props.tip : ''
  if (display) {
    return (
      <Tooltip title={tip}>
        <KeyboardBackspace className='arrow' />
      </Tooltip>
    )
  }
  return null
}
